<template>
  <div class="bg-white rounded-lg shadow p-6">
    <h3 class="text-lg font-semibold text-gray-800">
      {{ title }}
      <span class="text-sm text-gray-500">{{ subtitle }}</span>
    </h3>
    <p class="text-sm text-gray-600 mt-2">
      {{ description }}
    </p>
    <div v-if="chartReady" class="mt-4">
      <apexchart
        type="bar"
        height="400"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <div v-else class="text-gray-500 text-center py-8">
      Sin datos disponibles
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "QualityReportsBarChart",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {};
  },
  props: {
    title: { required: true, type: String },
    subtitle: { type: String },
    description: { type: String },
    categories: { required: true, type: Array, default: () => [] },
    series: { required: true, type: Array, default: () => [] },
    yTitle: { type: String, default: "" },
    colors: { type: Array, default: () => [] },
    tooltipFormatter: { type: Function, default: val => val },
    dataLabelFormatter: { type: Function, default: val => val },
    displayDataLabels: { type: Boolean, default: false },
    stacked: { type: Boolean, default: false }
  },
  created() {},
  computed: {
    chartReady() {
      return this.series.length > 0;
    },

    chartOptions: function () {
      return {
        chart: {
          type: "bar",
          stacked: this.stacked,
          toolbar: { show: true }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
            borderRadius: 4,
            dataLabels: {
              position: "top",
              borderRadiusApplication: "end"
            }
          }
        },
        dataLabels: {
          enabled: this.displayDataLabels,
          offsetY: this.stacked ? 0 : -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          },
          formatter: this.dataLabelFormatter
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: this.categories
        },
        yaxis: {
          title: {
            text: this.yTitle
          },
          min: 0,
          step: 1
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: this.tooltipFormatter
          }
        },
        colors: this.colors
      };
    }
  },
  methods: {},
  watch: {}
};
</script>
